import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import _Button from "../../../generic/_Button";
const Picker = lazy(() => import("emoji-picker-react"));
import { HIDDEN_EMOJIS } from "../../../../utils/const";
const Emoji = ({ onChange }) => {
  const popover = (
    <Popover id="popover-emoji">
      <Popover.Body className="absolute z-[9999]">
        <Suspense
          fallback={
            <div className="p-5 text-center bg-white px-4 py-2">Cargando…</div>
          }
        >
          <Picker
            onEmojiClick={(emojiData) => {
              onChange(emojiData);
            }}
            emojiStyle="native"
            searchPlaceHolder="Buscar emoji"
            skinTonesDisabled={true}
            // Configuración minimalista
            emojiVersion="1.0"
            //categories={["smileys_people"]}
            recent={false}
            previewConfig={false}
            suggestedEmojisMode="none"
            disableAutoFocus={true}
            hiddenEmojis={HIDDEN_EMOJIS}
          />
        </Suspense>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      emojis
      placement="bottom-start"
      overlay={popover}
      rootClose
    >
      <_Button icon="emoji_emotions" style="none" title="Emoji" />
    </OverlayTrigger>
  );
};

Emoji.propTypes = {
  onChange: PropTypes.func,
  style: PropTypes.string,
};

export default Emoji;
